<main class="main-home-secton">
  <div class="event-main">
    <div class="div-header">
      <h1>Events</h1>
    </div>
    <div class="container">
      <div class="event-title">
        <h2>Events by Incubators</h2>
      </div>
      <div class="div-contents" *ngIf="noData == false">
        <div class="row">
          <div
            class="col-lg-4 col-md-6 col-sm-12 col-12"
            *ngFor="let list of disList; let i = index"
          >
            <div class="events-div">
              <div class="blog-img-div">
                <img
                  [src]="list.eventImageName"
                  alt=""
                  class="img-fluid events-img"
                />
              </div>
              <div class="event-titles">
                <h5>{{ list.eventName }}</h5>
                <span>{{ list.incubatorName }}</span>
                <div class="event-footer mb-2">
                  <div class="event-time mt-5">
                    <i class="far fa-calendar-alt"></i>
                    <span class="ml-2 mr-2">{{ list.eventFromDate }}</span>
                    <div class="d-flex mt-2">
                      <i class="fas fa-map-marker-alt ms-1"></i>
                      <span class="ml-2" style="word-break: break-word">{{
                        showFullLocation[i]
                          ? list.eventLocation
                          : (list.eventLocation | slice : 0 : 20)
                      }}</span>
                    </div>
                  </div>
                  <div
                    class="event-location-footer"
                    *ngIf="shouldShowMore(list.eventLocation)"
                  >
                    <ng-container *ngIf="!showFullLocation[i]">
                      <a class="view-location" (click)="toggleLocation(i)"
                        >Show more</a
                      >
                    </ng-container>
                    <ng-container
                      *ngIf="showFullLocation[i]"
                      style="
                        overflow: auto; /* Enable scrolling */
                        max-height: 60px;
                      "
                    >
                      <a class="view-location" (click)="toggleLocation(i)"
                        >Show less</a
                      >
                    </ng-container>
                  </div>
                  <div class="border-line"></div>
                  <div class="event-register">
                    <button class="view-btn" (click)="viewEvent(list.id)">
                      Register Now
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="pagination-div text-center m-3" *ngIf="totalPages > 1">
          <button
            mat-mini-fab
            color="accent"
            class="set-page mr-2"
            [disabled]="currentPage == 1"
            (click)="paginatePartList('prev')"
          >
            <i class="fas fa-chevron-left"></i>
          </button>
          <button
            mat-mini-fab
            color="accent"
            class="set-page"
            [disabled]="currentPage == totalPages"
            (click)="paginatePartList('next')"
          >
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>
      <div class="div-contents" *ngIf="noData == true">
        <div class="text-center no-data-div">
          <img src="assets/images/startup-logo.png" class="img-fluid" alt="" />
          <h6>Coming Soon</h6>
        </div>
      </div>
    </div>
  </div>
</main>
<app-footer></app-footer>
